import { themeLss } from "../../lss";
import styled from "../../styled";
// The properties that are default to system can be overriden
// The ones being defined after it cannot
export var TransparentButton = styled.button(themeLss({
    border: 'none',
    color: 'inherit'
}), {
    background: 'transparent',
    cursor: 'pointer'
});
//# sourceMappingURL=TransparentButton.js.map